import React from "react";

import { Swiper, SwiperSlide } from "swiper/react";

import { Pagination, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";

import { featuredProjects } from "./projectData";

function FeaturedSection() {

  return (

    <section className="featured-section">

      <div className="container featured-window">

        <div className="featured-topbar">

          <div className="window-dots">
            <span></span>
            <span></span>
            <span></span>
          </div>

          <div className="featured-title">
            divsFeatured.fig
          </div>

        </div>

        <Swiper
          slidesPerView={1}
          spaceBetween={30}
          loop={true}
          autoplay={{
            delay: 5500,
            disableOnInteraction: false,
          }}
          pagination={{
            clickable: true,
          }}
          modules={[Pagination,Autoplay]}
          className="featured-swiper"
        >

          {featuredProjects.map((item) => (

            <SwiperSlide key={item.id}>

              <div className="featured-card">

                <div className="featured-image-wrapper">

                  <img
                    src={item.image}
                    alt={item.title}
                    className="featured-image"
                  />

                  <div className="featured-overlay"></div>

                  <div className="featured-content">

                    <h2>
                      {item.title}
                    </h2>

                    <small className="text-white">
                      {item.category}
                    </small>
                    <p>
                      {item.desc}
                    </p>
                    {item.link && (

                      <a
                        href={item.link}
                        target="_blank"
                        rel="noreferrer"
                        className="featured-tag"
                      >
                        View Live
                      </a>

                    )}

                  </div>

                </div>

              </div>

            </SwiperSlide>

          ))}

        </Swiper>

      </div>

    </section>

  );
}

export default FeaturedSection;